import api from '../lib/api'
import assign from 'lodash.assign'
import global from '../types/global.types'

const name = 'sign-up-result'

export default {
  name,
  namespaced: true,
  state () {
    return {
      show: false,
      list: [
        // ['学习时间：', '2017.10.23  至  2017.10.25'],
        ['学习方式：', '微课公众号-我的-个人中心']
      ],
      hasCourseGroup: {},
      wxinfo: '',
      isSubscribe: false,
      loading: true
    }
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async getQrCode ({ commit }, courseId) {
      // 特殊课程处理, 直接展示二维码
      if (courseId === 'f67434b66fb4456884ba69d495c80265') {
        commit('set', { wxinfo: 'https://edu-fe.ks3-cn-beijing.ksyun.com/edu-m/assets/1yuan-special-course-qrcode.png', loading: false })
      } else {
        const res = await api.payment.getPaySuccessQRCode(courseId)()
        commit('set', { wxinfo: res.data, loading: false })
      }
    },

    setRedirectFlag ({ commit }) {
      commit(global.SET_REDIRECT_FLAG, {}, { root: true })
    },

    async getSubsribe ({ commit }) {
      const { data } = await api.group.isSubsribe()
      commit('set', { isSubscribe: data })
    }
  }
}
